import React from "react";
import Barclays from "../../media/images/barclays.png"
import PostOffice from "../../media/images/post-office.png"
import TSB from "../../media/images/TSB.png"
import Santander from "../../media/images/santander.png"
import LloydsBank from "../../media/images/lloyds-bank.png"
import SainsburysBank from "../../media/images/sainsburys-bank.png"
import Halifax from "../../media/images/halifax.png"
import HSBC from "../../media/images/HSBC.png"
import Natwest from "../../media/images/natwest.png"
import MAndSBank from "../../media/images/ms-bank.png"

const ProviderList = () => {
  return (
    <div className="providers-holder clearfix">
      <h2>Some of the providers we search</h2>
      <p>
        We search more than 16 providers for credit cards and loans, some of the
        big ones are listed below. Unfortunately we don't cover the whole market
        yet, but we're working hard to add new providers all the time.
      </p>
      <ul className="provider-list" id="providers">
        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={118}
              height={21}
              itemProp="logo"
              src={Barclays}
              alt="Barclays"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={67}
              height={50}
              itemProp="logo"
              src={PostOffice}
              alt="Post Office"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img width={94} height={34} itemProp="logo" src={TSB} alt="TSB" />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={132}
              height={36}
              itemProp="logo"
              src={Santander}
              alt="Santander"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={91}
              height={49}
              itemProp="logo"
              src={LloydsBank}
              alt="Lloyds bank"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={100}
              height={35}
              itemProp="logo"
              src={SainsburysBank}
              alt="Sainsbury's bank"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={81}
              height={42}
              itemProp="logo"
              src={Halifax}
              alt="Halifax"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={117}
              height={25}
              itemProp="logo"
              src={HSBC}
              alt="HSBC"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={115}
              height={21}
              itemProp="logo"
              src={Natwest}
              alt="Natwest"
            />
          </span>
        </li>

        <li
          itemProp="provider"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span>
            <img
              width={111}
              height={16}
              itemProp="logo"
              src={MAndSBank}
              alt="M&S Bank"
            />
          </span>
        </li>
      </ul>

      <p>
        MoneySavingExpert.com Limited is an appointed representative of
        Moneysupermarket.com Financial Group Limited, which is authorised and
        regulated by the Financial Conduct Authority (FCA FRN 303190).
        Moneysupermarket.com Financial Group Limited, registered in England No.
        3157344. Registered Office: Moneysupermarket House, St. David's Park,
        Ewloe, CH5 3UZ.
      </p>
    </div>
  );
};

export default ProviderList;
